  import { Box, Flex, Image, Text, VStack,useColorMode,Heading } from '@chakra-ui/react';
  import { FaCheckCircle } from 'react-icons/fa'; // Import the relevant icon
  import { motion } from 'framer-motion';
  import "../../App.css"
 import { experiences } from './constants';
import { useEffect } from 'react';



  const ExperienceCard = ({ companyLogo, companyName, role, workPoints, date }) => {

    return (
      <Box
        borderWidth="1px"
        borderRadius={["2rem", "1.5rem", ".5rem", ".5rem"]} // Responsive borderRadius
        p={["2", "2", "4", "4"]} // Responsive padding
        mb={"50px"}
        display="flex"
        flexDirection={["column", "column", "column", "row"]} // Adjust flex direction
        alignItems={["center", "center", "flex-start", "center"]} // Responsive alignItems
        justifyContent="space-between"
        transition="transform 0.3s"
        boxShadow="0 4px 6px rgba(0, 0, 0, 0.1)"
        _hover={{ transform: 'scale(1.05)' }}
        width={["100%", "100%", "100%", "100%"]} // Responsive width
        gap={"24px"}
      >
        {/* Left side: Company logo */}
        <Box mr={[0, 0, 4, 0]} display="flex" alignItems="center" justifyContent="center">
          <Image objectFit="contain" src={companyLogo} alt={`${role}`} boxSize={["100px", "100px", "200px", "200px"]} /> {/* Responsive image size */}
        </Box>
  
        {/* Right side: Role details */}
        <VStack align={["center", "center", "start", "start"]} spacing={2} flex="1">
          <Flex direction={["column", "column", "row", "row"]} justify="space-between" align="start" w="100%" fontFamily="Times New Roman">
          <Flex display="flex" fontWeight="bold" fontSize={["md", "xl", "2xl", "2rem"]}>
            <Text fontFamily={"Times New Roman"}>
              {role}
            </Text>
            <Text mx={2}>-</Text>
            <Text color="purple.700" fontFamily={"Times New Roman"}>
              {companyName}
            </Text>
          </Flex>
            <Text alignSelf={["start","start", "end", "end"]} color="gray.500" fontFamily="Roboto">{date}</Text>
          </Flex>
          <Box w="100%" borderBottom="1px solid gray" my={2} />
          {workPoints.map((point, index) => (
            <Flex key={index} align="start">
              <Box as={FaCheckCircle} color="green.500" mt={1} mr={2} />
              <Text fontSize={["sm", "md", "lg", "lg"]} fontFamily="Roboto">{point}</Text>
            </Flex>
          ))}
        </VStack>
      </Box>
    );
  };

  const ExperienceSection = () => {
   

    const { colorMode } = useColorMode();
    const bgColor = colorMode === "light" ? "white" : "dark";
    const gradientColor = `linear-gradient(135deg, #FF6B6B, #7873F5)`;

    useEffect(()=>{
      window.scrollTo(0,0);
    })

    return (

      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -50 }}
        transition={{ duration: 0.5 }}      
      >

        <Flex direction="column" align="center" minHeight="100vh" bgColor={bgColor}>
        {/* Colorful heading */}
          <Heading fontSize={['2xl', '4xl', '7xl']} fontFamily="Times New Roman" textAlign="center">
            <Text
              // as="span"
              bgGradient={gradientColor}
              bgClip="text"
              fontFamily={"Times New Roman"}
            >
              My Experiences
            </Text>
          </Heading>
          {/* Small paragraph */}
          <Text fontSize={['md', 'lg']} textAlign="center" color="gray.500" mb={8}>
            A summary of my Experiences :)
          </Text>
          {/* Project components */}
          <Flex direction="column" align="center" p={8}>
            {experiences.map((experience, index) => (
              <ExperienceCard key={index} {...experience} />
            ))}
          </Flex>
        </Flex>








        {/* <Flex direction="column" align="center" p={8}>
        {experiences.map((experience, index) => (
          <ExperienceCard key={index} {...experience} />
        ))}
      </Flex> */}


      </motion.div>

      
    );
  };

  export default ExperienceSection;
